import React, {Fragment, useLayoutEffect, useState, useEffect}  from 'react';
import SiteDisplay from './SiteDisplay';
import _ from 'lodash';
import {
	PublishSubscribe,
	ApiService
	//HaulCheckService,
	//userService
} from '../../../services'
import {addChildToArray, removeChildFromArray, usePrevious} from '../../../utils'

export default function SiteList({name, passedSites, emptyState, listObj, switchSidePanel, hasGroup, activeSite, setActiveSite, selectedMaterial, setSelectedMaterial, openSiteTeamModal, getSiteInfo, openSettingsModal, deleteMaterial, editSiteName, deleteSite, activeTab, idpmgroup, newSite, moveSite, clearNewSite, addLength, removeLength, isMobile, isBrowser, hasExternalAccess, isSeedUser}){

	let [sites, updateSites] = useState(passedSites ? _.cloneDeep(passedSites) : []);
	let [realSiteLength, setRealSiteLength] = useState(passedSites ? passedSites.length : 0);
	let previousRealSiteLength = usePrevious(realSiteLength, 0)
	let previousActiveTab = usePrevious(activeTab, "mySites")
	let iddiscoverymode = (listObj == "postsList" ? 2 : listObj == "bidsList" ? 1 : null)
	let username = ApiService.getJWTUsername();

	useLayoutEffect(() => {
		if (JSON.stringify(passedSites) != JSON.stringify(sites)){
			updateSites(passedSites ? _.cloneDeep(passedSites) : []);
			setRealSiteLength(passedSites ? passedSites.length : 0)
		}
	}, [passedSites])


	let PS = PublishSubscribe.usePublishSubscribe({
		origin: "HC-frontend/MySites/Sidebar/SiteList/"+listObj+"/"+iddiscoverymode,
	  	topic: "HC/sites",

	  	callback: (message) => {
			//message = JSON.parse(message);

			console.log("AMQ parsed emssage for siteList:", message, message.identifier.iddiscoverymode, iddiscoverymode, message.identifier.iddiscoverymode == iddiscoverymode)

			if (message.type == "new-site" && (message.identifier.iddiscoverymode == iddiscoverymode || message.identifier.iddiscoverymode == 0 && iddiscoverymode == null)){
				updateSites((previousState) => {return addChildToArray(previousState, message.site, "idsite", "name")})
				setRealSiteLength(prev => prev+1)
			}
		},

	  	identifier: {
	  		iddiscoverymode,
	  		tab: (activeTab == "groupSites" ? "group" : activeTab == "mySites" ? "mine" : activeTab == "material" ? "material"  : ""),
	  		idpmgroup: (activeTab == "groupSites" ? idpmgroup : activeTab == "mySites" ? undefined : activeTab == "material" ?  (idpmgroup ? idpmgroup : null)  : null),
	  		username: (activeTab == "groupSites" ? undefined : activeTab == "mySites" ? username : activeTab == "material" ?  (idpmgroup ? null : username)  : null),

	  	},

	})


	useLayoutEffect(() => {
		console.log("---------- realSiteLength ----------")
		console.log("realSiteLength set to " + realSiteLength + " in listObj " + listObj);
		console.log("previous realSiteLength:", previousRealSiteLength);

		if (previousRealSiteLength > realSiteLength){
			removeLength();
		} else if (previousRealSiteLength < realSiteLength){
			addLength();
		}
		
	}, [realSiteLength])

	useLayoutEffect(() => {

		if ((activeTab == "material" && previousActiveTab !== "material") || (activeTab != "material" && activeTab == "material")){
			setActiveSite(null);
		}

	}, [activeTab])

	
	useLayoutEffect(() => {
		console.log("newSite in listObj " + listObj);
		if (newSite != null){
			console.log("newSite being passed to siteList "+listObj+" with iddiscoverymode "+newSite.iddiscoverymode+":", newSite);
			if (newSite.iddiscoverymode == iddiscoverymode){
				console.log("newSite being added to siteList with listObj " + listObj + " and newSite ", newSite);
				updateSites(previousState => addChildToArray(previousState, newSite, "idsite", "name"))
				setRealSiteLength(prev => prev+1);
				clearNewSite();
			}
		}
	}, [newSite])

	let renderSiteDisplay = (site, key) => {
		return <SiteDisplay
			isBrowser={isBrowser}
			isMobile={isMobile}
			passed_site={site}
			index={key}
			listObj={listObj}
			switchSidePanel={switchSidePanel}
			sortMode={activeTab}
			key={site.idsite || site.name}
			hasGroup={hasGroup}
			isActiveSite={activeTab != "material" ? activeSite == site.idsite : activeSite == key}
			setActiveSite={setActiveSite}
			setSelectedMaterial={setSelectedMaterial}
			selectedMaterial={selectedMaterial}
			openSiteTeamModal={openSiteTeamModal}
			getSiteInfo={getSiteInfo}
			openSettingsModal={openSettingsModal}
			canEditSite={ true }
			deleteMaterial={deleteMaterial}
			editSiteName={editSiteName}
			deleteSite={deleteSite}
			activeTab={activeTab}
			idpmgroup={idpmgroup}
			hasExternalAccess={hasExternalAccess}
			removeSelf={(idsite) => {
				if (activeTab != "material"){
					updateSites(previousState => removeChildFromArray(previousState, idsite, "idsite"))
				}

				if (activeSite == idsite){
					setActiveSite(0)
				}

				setRealSiteLength(prev => prev-1)
			}}
			addSelf={() => setRealSiteLength(prev => prev+1)}
			moveSelf={(siteToMove) =>{ 
				console.log("Calling moveSelf");
				moveSite(siteToMove);
				//removeSelf is also called if moveSelf is called, so realSiteLength doesn't need to be updated
			}}
			isSeedUser={isSeedUser}
		/>
	}

	if (realSiteLength > 0){
		return <>
			{name !== null ? <label className={"strong mt-4" + (isMobile ? " mb-2" : "")}>{name}</label> : null}
			<div className="row pb-4 mb-2">
				{sites.map((site, key) => {
					if (site) {
						return renderSiteDisplay(site, key)
					} else {
						return null
					}
				})}
			</div>
		</>
	} else return emptyState

}